/** Monetary amount helpers (frontend) — mirror backend/utils/amountUtils.js */

export function roundMoney(value, decimals = 2) {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  const factor = 10 ** decimals;
  return Math.round((num + Number.EPSILON) * factor) / factor;
}

export function applyInvoiceRoundOff(totalValue, totalTaxAmount) {
  const taxable = roundMoney(totalValue);
  const tax = roundMoney(totalTaxAmount);
  const totalAmountBeforeRoundOff = roundMoney(taxable + tax);
  const totalAmountWithTax = Math.round(totalAmountBeforeRoundOff);
  const roundOffAmount = roundMoney(totalAmountWithTax - totalAmountBeforeRoundOff);

  return {
    totalValue: taxable,
    totalTaxAmount: tax,
    totalAmountBeforeRoundOff,
    roundOffAmount,
    totalAmountWithTax,
  };
}

export function formatAmount(value) {
  return roundMoney(value).toFixed(2);
}
